// Global Components
import * as React from 'react';

// Types
type $Props = {
  dataSortConfig: null | string;
  label: string;
  onSort: (dataSortConfig: string) => void;
  sortKey: string;
};

type $Values = {
  activeKey: boolean;
  newSortDirection: 'asc' | 'desc';
};

const getValues = ({
  dataSortConfig,
  sortKey,
}: {
  dataSortConfig: null | string;
  sortKey: string;
}): $Values => {
  const values: $Values = {
    activeKey: false,
    newSortDirection: 'asc',
  };

  if (dataSortConfig !== null) {
    const [currentKey, currentDirection] = dataSortConfig.split(':');

    values.activeKey = currentKey === sortKey;

    if (values.activeKey === true && values.newSortDirection === currentDirection) {
      values.newSortDirection = 'desc';
    }
  }

  return values;
};

const ThSortView = function ({
  dataSortConfig,
  label,
  onSort,
  sortKey,
}: $Props) {
  const {
    activeKey,
    newSortDirection,
  } = getValues({
    dataSortConfig,
    sortKey,
  });

  return (
    <th
      onClick={() => onSort(`${sortKey}:${newSortDirection}`)}
    >
      {activeKey === true ? (
        <em className={`fa fa-sort-${newSortDirection === 'desc' ? 'up' : 'down'} mr-1`} />
      ) : (
        <em className={'fa fa-sort text-muted mr-1'} />
      )}
      <span>
        {label}
      </span>
    </th>
  );
};

export default ThSortView;
